import styled from 'styled-components';

export const StyledContent = styled.div`
  .identity__form {
    width: 100%;
    display: flex;
    flex-direction: column;

    .identity__field {
      margin-bottom: 24px;

      #email:autofill + label {
        transition: all 0.3s ease 0s;
        font-size: 10px;
        top: 8px;
      }
    }
  }

  .form-buttom {
    margin: 0;
  }

  .identity__alert-text a span {
    color: inherit;
  }
`;
